// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-3,5-13周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "耿爱成",
      "week": "1-8,11-18双周",
      "add": "教学楼C座215教务"
    },
    0,
    {
      "sub": "科技文献检索",
      "tec": "冯晓丽",
      "week": "1-3,5周",
      "add": "教学楼C座115教务"
    },
    0
  ],
  "2": [
    {
      "sub": "基础工业工程",
      "tec": "马彤兵",
      "week": "1-16周",
      "add": "教学楼D座222经管"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25经管法1-6",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-3",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-2",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "25经管法2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼D座315文法"
      },
      {
        "sub": "25经管法1-4",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "25经管法2-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-1",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25经管法1-5",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      }
    ],
    {
      "sub": "管理运筹学",
      "tec": "刘捷",
      "week": "5-16周",
      "add": "教学楼D座221经管"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "商晶",
      "week": "1-16周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "马彤兵",
      "week": "2-6周",
      "add": "教学楼D座226经管"
    }
  ],
  "3": [
    {
      "sub": "人因工程",
      "tec": "郭艳秋",
      "week": "1-16周",
      "add": "教学楼D座224经管"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-3,5-13周",
      "add": "教学楼D座315文法"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "管理运筹学",
      "tec": "刘捷",
      "week": "5-16周",
      "add": "教学楼D座221经管"
    },
    0,
    {
      "sub": "智能制造系统",
      "tec": "刘伟刚",
      "week": "1-16周",
      "add": "教学楼D座221经管"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女乒",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "搏击",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "郝策",
        "week": "1-12,14-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "足球",
        "tec": "李灏",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男乒",
        "tec": "李莉",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女羽",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "健美操"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "1-4周",
      "add": "教学楼C座311教务"
    }
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "耿爱成",
      "week": "1-8,11-18周",
      "add": "教学楼C座215教务"
    },
    [
      {
        "sub": "人因工程",
        "tec": "郭艳秋",
        "week": "1-8周",
        "add": "教学楼D座222经管"
      },
      {
        "sub": "基础工业工程",
        "tec": "马彤兵",
        "week": "9-16周",
        "add": "教学楼D座222经管"
      }
    ],
    [
      {
        "sub": "大学英语（三）",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "25经管法1-7",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25经管法2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-4",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25经管法2-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-1",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "25经管法1-6",
        "tec": "马丹",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "25经管法1-3",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
